import {useState} from "react";

import {
  createExportTask,
  downloadExportTaskFile,
  getExportTaskStatus
} from "api/export";
import type {ExportTask} from "api/export";

import type {Notification} from "../types";

const waitForExportTask = async (task: ExportTask): Promise<ExportTask> => {
  let currentTask = task;

  while (currentTask.status === 'PENDING' || currentTask.status === 'PROCESSING') {
    await new Promise((resolve) => window.setTimeout(resolve, 2000));
    currentTask = await getExportTaskStatus(currentTask.id);
  }

  return currentTask;
};

const useFolderExport = (
  subcategoryId: string | undefined,
  setNotification: (notification: Notification) => void,
) => {
  const [activeExportPath, setActiveExportPath] = useState<string | null>(null);

  const handleExportFolder = async (path: string) => {
    if (!subcategoryId || activeExportPath) {
      return;
    }

    setActiveExportPath(path);

    try {
      const task = await createExportTask(subcategoryId, path);
      const completedTask = await waitForExportTask(task);

      if (completedTask.status === 'ERROR') {
        throw new Error(completedTask.errorMessage || 'Не удалось сформировать архив');
      }

      await downloadExportTaskFile(completedTask.id);
    } catch (error) {
      setNotification({
        message: error instanceof Error ? error.message : 'Не удалось сформировать архив',
        severity: 'error',
      });
    } finally {
      setActiveExportPath(null);
    }
  };

  return {
    activeExportPath,
    handleExportFolder,
  };
};

export default useFolderExport;
